module.exports = __webpack_public_path__ + "static/img/rm_brand_back_aimei_top.0bc5a23.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/rm_brand_img/rm_brand_back_aimei_top.png
// module id = fvve
// module chunks = 1